import React from "react";

/**
 * Ant Design Select 下拉選單的空狀態／錯誤提示（含 icon + 文字，避免顯示「無此資料」）。
 */
const SelectDropdownEmptyHint = ({
  Icon,
  message,
  description,
  iconSize = 32,
  spinning = false,
}) => (
  <div
    className="d-flex flex-column align-items-center text-center"
    style={{
      color: "#888",
      maxWidth: 280,
      margin: "0 auto",
      padding: "16px 12px",
    }}
    role="status"
  >
    {Icon ? (
      <Icon
        size={iconSize}
        aria-hidden
        style={{
          color: "#c8c8c8",
          marginBottom: description ? 8 : 10,
          flexShrink: 0,
          animation: spinning ? "selectDropdownEmptyHintSpin 0.8s linear infinite" : undefined,
        }}
      />
    ) : null}
    <span
      style={{
        fontSize: 14,
        fontWeight: 600,
        color: "#444",
        lineHeight: 1.4,
      }}
    >
      {message}
    </span>
    {description ? (
      <span
        style={{
          fontSize: 13,
          color: "#888",
          marginTop: 6,
          lineHeight: 1.5,
        }}
      >
        {description}
      </span>
    ) : null}
    {spinning ? (
      <style>{`@keyframes selectDropdownEmptyHintSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    ) : null}
  </div>
);

export default SelectDropdownEmptyHint;
